export default "__VITE_ASSET__C7hzZ4LX__"